import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import { ExecutionResult } from "@apollo/react-common";
import {
  UpdateCartProps,
  UpdateCartData,
  useUpdateCart,
} from "src/hooks/useUpdateCart";
import { CartUpdateAction } from "src/types/ctgraphql.d";

interface DeleteCartItemHook {
  data?: UpdateCartData;
  loading: boolean;
  error?: ApolloError;
  deleteCartItem: (
    lineItemIds: string[]
  ) => Promise<ExecutionResult<UpdateCartData> | undefined>;
}

const useDeleteCartItem = ({
  refetchQueries = [],
  onCompleted,
}: UpdateCartProps = {}): DeleteCartItemHook => {
  const { updateCart, loading, error } = useUpdateCart({
    refetchQueries,
    onCompleted,
  });

  const deleteCartItem = useCallback(
    (lineItemIds: string[]) => {
      const lineItemsToBeRemoved: CartUpdateAction[] = lineItemIds?.map(
        (lineItemId: string) => ({
          removeLineItem: {
            lineItemId,
          },
        })
      );
      return updateCart(lineItemsToBeRemoved);
    },
    [updateCart]
  );

  return {
    deleteCartItem,
    loading,
    error,
  };
};

export { useDeleteCartItem };
